module.exports = __webpack_public_path__ + "fonts/Caveat-Medium.a33c8183.ttf";